import { IdValue } from '../../../shared/models/id-value.model';
import { mapToIdValues } from '../../../shared/utils';
import { DpFactorType, MortgageType, PmiType, PurposeOfLoan, UpfrontMiType } from '../loan-information.model';
import { OriginationChannel } from '../origination-channel.enum';
import { ProductDescription } from '../product-description.enum';

export const affordableLoanOptions = [new IdValue(0, true, 'Yes'), new IdValue(1, false, 'No')];

export const fundSourceTypeOptions = [
  new IdValue(0, 0, 'Select'),
  new IdValue(0, 1, 'Community Non Profit'),
  new IdValue(0, 2, 'Federal Agency'),
  new IdValue(0, 3, 'Institutional'),
  new IdValue(0, 4, 'Lender'),
  new IdValue(0, 5, 'Local Agency'),
  new IdValue(0, 6, 'Non Parent Relative'),
  new IdValue(0, 7, 'Non Profit Instrumentality of Government'),
  new IdValue(0, 8, 'Parent'),
  new IdValue(0, 9, 'Relative'),
  new IdValue(0, 10, 'Religious Non Profit'),
  new IdValue(0, 11, 'State Agency'),
  new IdValue(0, 12, 'Unmarried Partner'),
  new IdValue(0, 13, 'Unrelated Friend'),
];

export const organizationChannelOptions = [
  new IdValue(0, OriginationChannel.select, 'Select'),
  new IdValue(0, OriginationChannel.retail, 'Retail'),
  new IdValue(0, OriginationChannel.brokeredOut, 'Brokered Out'),
];
export const hasPrepaymentPenaltyOptions = [new IdValue(0, 1, 'Yes'), new IdValue(1, 2, 'No')];
export const productDescriptions = [
  new IdValue(0, ProductDescription.select, 'Select'),
  new IdValue(1, ProductDescription.standardLCOR, 'Standard LCOR'),
  new IdValue(2, ProductDescription.affordableLTV, 'Affordable LTV'),
  new IdValue(60, ProductDescription.other, 'Other'),
];

export const otherRefinancePurposeOptions = mapToIdValues(
  [
    'Select',
    'Cash-Out Debt Consolidation',
    'Cash-Out Home Improvement',
    'Limited Cash Out',
    'Cash-Out Other',
    'No Cash-Out FHA Streamlined Refinance',
    'No Cash-Out FRE Owned Refinance',
    'No Cash-Out Other',
    'No Cash-Out Streamlined Refinance',
    'Change in Rate Term',
  ],
  false,
);
export const fhaRefinancePurposeOptions = mapToIdValues(
  ['Select', 'Streamlined with Appraisal', 'Streamlined without Appraisal', 'No Cash-Out', 'Cash-Out'],
  false,
);

export const vaRefinancePurposeOptions = mapToIdValues(['Select', 'IRRRL', 'Other'], false);

export const loanProgramCodesVAForIRRR = [
  '4101 IRRL',
  '4103 IRRL',
  '4125 IRRL',
  '4129 IRRL',
  '4102 IRRL',
  '4104 IRRL',
  '4131 IRRL',
  '4131HBIRRL',
  '4151 IRRL',
  '4151HBIRRL',
];

export const upfrontMiTypeOptions = [
  new IdValue(0, UpfrontMiType.select, 'Select'),
  new IdValue(1, UpfrontMiType.paidInCash, 'Paid In Cash'),
  new IdValue(2, UpfrontMiType.financed, 'Financed'),
];

export const purposeOfLoanOptions = [
  new IdValue(0, PurposeOfLoan.select, 'Select'),
  new IdValue(1, PurposeOfLoan.purchase, 'Purchase'),
  new IdValue(2, PurposeOfLoan.refinance, 'Refinance'),
  new IdValue(5, PurposeOfLoan.second, 'Second'),
  new IdValue(6, PurposeOfLoan.third, 'Third'),
  new IdValue(7, PurposeOfLoan.purchaseMoneySecond, 'Purchase Money Second'),
  new IdValue(8, PurposeOfLoan.other, 'Other'),
  new IdValue(9, PurposeOfLoan.purchaseMoneyThird, 'Purchase Money Third'),
];

export const pmiTypeOptions = [
  new IdValue(null, PmiType.select, 'Select'),
  new IdValue(0, PmiType.none, 'None'),
  new IdValue(1, PmiType.monthly, 'Monthly'),
  new IdValue(2, PmiType.standard, 'Standard Annual'),
  new IdValue(3, PmiType.singlePremRefund, 'Single Prem. Refundable'),
  new IdValue(4, PmiType.singlePremNonRefund, 'Single Prem. Non-Refundable'),
  new IdValue(5, PmiType.lenderPaid, 'Lender Paid'),
  new IdValue(6, PmiType.splitPremNonRefund, 'Split Prem. Non-Refundable'),
];

export const mortgageAppliedForOptions = [
  new IdValue(0, MortgageType.notAssigned, 'Select'),
  new IdValue(1, MortgageType.va, 'VA'),
  new IdValue(2, MortgageType.fha, 'FHA'),
  new IdValue(3, MortgageType.conventional, 'Conventional'),
  new IdValue(4, MortgageType.usda, 'USDA'),
  new IdValue(5, MortgageType.other, 'Other'),
  new IdValue(6, MortgageType.heloc, 'HELOC'),
  new IdValue(7, MortgageType.stateAgency, 'State Agency'),
];

export const sectionOfActOptions = mapToIdValues(
  ['Select', '203(b)', '203(b)2', '203(b)/251', '203(k)', '203(k)/251', '221(d)(2)', '221(d)(2)/251', '234(C)', '234(C)/251', '184'],
  false,
);

export const amortizationTypeOptions = [
  new IdValue(0, 0, 'Fixed Rate'),
  new IdValue(1, 1, 'ARM'),
  new IdValue(3, 3, 'GPM'),
  new IdValue(4, 4, 'No Payment'),
];

export const dpFactorOptions = [
  new IdValue(0, DpFactorType.select, 'Select, Enter Base Loan'),
  new IdValue(1, DpFactorType.downpaymentPercentage, 'Down Payment Percentage (%)'),
  new IdValue(3, DpFactorType.downpaymentAmount, 'Down Payment Amount ($)'),
];

export const caseAssignmentDateOptions = mapToIdValues(
  [
    'Before 7/14/2008',
    '7/14/2008 - 9/30/2008',
    '10/1/2008 - 12/31/2008',
    '01/01/2009 - 04/04/2010',
    '4/5/2010 - 10/3/2010',
    '10/4/2010 - 4/17/2011',
    '4/18/2011 - 4/8/2012',
    '4/9/2012 - 6/10/2012',
    '6/11/2012 - 3/31/2013',
    '4/1/2013 - 6/2/2013',
    '6/3/2013 - 1/25/2015',
    '01/26/2015 - 09/30/2016',
    '10/01/2016 - 1/26/2017',
    '1/27/2017 - 8/31/2019',
    'On or After 9/1/2019',
  ],
  false,
);

export const gusRunFirstDateOptions = mapToIdValues(
  [
    'On or Before 09/30/2011',
    '10/1/2011 - 12/6/2011',
    '12/7/2011 - 9/30/2012',
    '10/1/2012 - 9/30/2014',
    '10/1/2014 - 9/30/2015',
    '10/01/2015 To 09/30/2016',
    'On or After 10/01/2016 ',
  ],
  false,
);

export const fundingFeeTypeOptions = mapToIdValues(
  [
    'Select',
    'Regular Military First Use',
    'Regular Military Subsequent Use',
    'Reserves or Guard First Use',
    'Reserves or Guard Subsequent Use',
    'Interest Rate Reduction Refi',
    'Manufactured Home',
    'Loan Assumption',
    'Exempt',
  ],
  false,
);
